import React from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import Table from "common/components/Table/Table.jsx";
import Button from "common/components/CustomButtons/Button.jsx";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

// @material-ui/core components
import DeviceHub from "@material-ui/icons/DeviceHub";

import MacRegistrationCard from "./AdvancedSettingsMacRegistrationCard.jsx";

import loadContent from "core-module/hoc/loadContent";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  ...regularFormsStyle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: {
    ...importedStyle.stats,
    alignSelf: "center",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  actionButton: {
    margin: "0 0 0 5px",
    padding: "5px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0px",
    },
  },
  buttonIcon: {
    verticalAlign: "middle",
    width: "17px",
    height: "17px",
    top: "-1px",
    position: "relative",
  },
  right: {
    textAlign: "right",
  },
  addAddress: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "15px",
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  legendContainer: {
    textAlign: "center",
  },
};

const IpCountCard = (props) => {
  const { classes } = props;
  let addDinamicDisabled = true;
  let addStaticDisabled = true;

  if (
    props.getData("base_used") < props.getData("base_available") ||
    props.getData("addon_used") < props.getData("addon_available")
  ) {
    addDinamicDisabled = false;
  }

  if (props.getData("addon_used") < props.getData("addon_available")) {
    addStaticDisabled = false;
  }

  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <DeviceHub />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>IP Address management</h4>
      </CardHeader>
      <CardBody>
        <GridItem xs={12} className={classes.legendContainer}>
          <MacRegistrationCard
            selectEdit={props.selectEdit}
            setIsLoading={props.setIsLoading}
            onCancelRegistration={props.onCancelRegistration}
          />
        </GridItem>
        <GridItem xs={12} className={classes.legendContainer}>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </GridItem>
        <GridContainer justify="center">
          <GridItem xs={12}>
            <Table
              tableHead={["From", "Type", "Registered/Total"]}
              tableData={[
                [
                  "Base package",
                  props.getData("base_canbestatic", "value")
                    ? "Static/Dynamic"
                    : "Dynamic",
                  props.getData("base_used") +
                    "/" +
                    props.getData("base_available"),
                ],
                [
                  "Add-on",
                  props.getData("addon_canbestatic", "value")
                    ? "Static/Dynamic"
                    : "Dynamic",
                  props.getData("addon_used") +
                    "/" +
                    props.getData("addon_available"),
                ],
              ]}
            />
            <div className={classes.addAddress} />
          </GridItem>
          <GridItem xs={12} sm={6}>
            <Button
              fullWidth
              disabled={addDinamicDisabled}
              onClick={() => props.selectCreate("dynamic")}
              color={addDinamicDisabled ? "default" : "primaryLightBlue"}
            >
              Register Dynamic IP address
            </Button>
          </GridItem>
          <GridItem xs={12} sm={6}>
            <Button
              fullWidth
              disabled={addStaticDisabled}
              onClick={() => props.selectCreate("static")}
              color={addStaticDisabled ? "default" : "primaryLightBlue"}
            >
              Register Static IP address
            </Button>
          </GridItem>
          <GridItem xs={12} className={classes.legendContainer}>
            <div className={classes.stats}>
              <h4>
                (Additional IP addresses and/or static IP addresses are
                available by calling MCSnet support. If you encounter
                difficulties with your service, please remember that we are here
                to assist you at any time.)
              </h4>
            </div>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(
  loadContent("user.session/ipaddr_count", IpCountCard)
);
